export const DataSourceOrigins = ['resident'] as const;

export type DataSourceOriginsType = (typeof DataSourceOrigins)[number];

export const DataSourceOriginsMap: { [key in DataSourceOriginsType]: number } = {
  resident: 1,
};
